import { useState, useEffect } from 'react';

function formatRemaining(ms: number): string {
  if (ms <= 0) return '0:00:00';
  const d = Math.floor(ms / 86_400_000);
  const h = Math.floor((ms % 86_400_000) / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  const s = Math.floor((ms % 60_000) / 1_000);
  if (d > 0) return `${d}d ${h}h ${m}m ${s}s`;
  if (h > 0) return `${h}h ${m}m ${s}s`;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function useCountdown(targetIso: string): string {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1_000);
    return () => clearInterval(id);
  }, []);

  const remaining = new Date(targetIso).getTime() - now;
  return formatRemaining(remaining);
}
